import {useState} from "react";
import {useTranslation} from "../../contexts/TranslationContext";
import {LoadingOutlined} from "@ant-design/icons";
import {Modal} from "antd";
import {Button} from "../../shared/components/Button";
import "./PrivacyModal.css"

const PrivacyModal = ({ consentMode = false, open: externalOpen, onAccept, onDecline, isAccepting = false }) => {
    const [internalOpen, setInternalOpen] = useState(false);
    const { translate } = useTranslation();
    const open = consentMode ? externalOpen : internalOpen;

    return (
        <>
      {!consentMode && (
        <span
            className="text-primary underline cursor-pointer"
            style={{ fontSize: "12px" }}
            onClick={() => setInternalOpen(true)}
        >
          {translate("SIGN_UP.PRIVACY.TITLE")}
        </span>
      )}
            <Modal
                className={'privacyModal'}
                closable={!consentMode}
                maskClosable={!consentMode}
                width={1000}
                open={open}
                onCancel={consentMode ? undefined : () => setInternalOpen(false)}
                footer={
                    consentMode ? (
                        <div className="flex gap-3 justify-end">
                            <Button
                            mode="complaintSecondary"
                                onClick={onDecline}
                                disabled={isAccepting}
                                className="px-8 border border-primary text-primary bg-white"
                            >
                                {translate("SIGN_UP.PRIVACY.DECLINE") || "Decline"}
                            </Button>
                            <Button
                                onClick={onAccept}
                                disabled={isAccepting}
                                className="px-8"
                            >
                                {isAccepting ? <LoadingOutlined /> : (translate("SIGN_UP.PRIVACY.ACCEPT") || "Accept")}
                            </Button>
                        </div>
                    ) : (
                        <>
                            <Button onClick={() => setInternalOpen(false)} className="px-8">
                                {translate("SIGN_UP.DONE")}
                            </Button>
                        </>
                    )
                }
                title={
                    <div className="uppercase text-primary text-lg font-bold mb-8">
                        {translate("privacy_note.title_1")}
                    </div>
                }
            >
                <section>
                    <p className="headText">{translate('privacy_note.title')}</p>
                    <p>{translate('privacy_note.content')}</p>
                </section>

                <section>
                    <p className="headText">{translate('personal_data_collection_processing_disclosures.title')}</p>
                    <div
                        className="subHead">{translate('personal_data_collection_processing_disclosures.collection.title')}</div>
                    <ul>
                        <li>{translate('personal_data_collection_processing_disclosures.collection.content')}</li>
                    </ul>

                    <div
                        className="subHead">{translate('personal_data_collection_processing_disclosures.types.title')}</div>
                    <ul>
                        <li>{translate('personal_data_collection_processing_disclosures.types.content_1')}</li>
                        <li>{translate('personal_data_collection_processing_disclosures.types.content_2')}</li>
                        <li>{translate('personal_data_collection_processing_disclosures.types.content_3')}</li>
                        <li>{translate('personal_data_collection_processing_disclosures.types.content_4')}</li>
                        <li>{translate('personal_data_collection_processing_disclosures.types.content_5')}</li>
                        <li>{translate('personal_data_collection_processing_disclosures.types.content_6')}</li>
                    </ul>
                </section>

                <section>
                    <p className="headText">{translate('personal_data_collection_processing_disclosures.methods.title')}</p>
                    <div className="subHead">{translate('personal_data_collection_processing_disclosures.methods.direct.title')}</div>
                    <p>{translate('personal_data_collection_processing_disclosures.methods.direct.content')}</p>
                    <div className="subHead">{translate('personal_data_collection_processing_disclosures.methods.indirect.title')}</div>
                    <p>{translate('personal_data_collection_processing_disclosures.methods.indirect.content')}</p>
                </section>

                <section>
                    <p className="headText">{translate('personal_information_collection.title')}</p>

                    <div className="subHead">{translate('personal_information_collection.what_we_collect.title')}</div>
                    <ul>
                        <li>{translate('personal_information_collection.what_we_collect.content_1')}</li>
                        <li>{translate('personal_information_collection.what_we_collect.content_2')}</li>
                        <li>{translate('personal_information_collection.what_we_collect.content_3')}</li>
                        <li>{translate('personal_information_collection.what_we_collect.content_4')}</li>
                        <li>{translate('personal_information_collection.what_we_collect.content_5')}</li>
                        <li>{translate('personal_information_collection.what_we_collect.content_6')}</li>
                        <li>{translate('personal_information_collection.what_we_collect.content_7')}</li>
                        <li>{translate('personal_information_collection.what_we_collect.content_8')}</li>
                    </ul>

                    <div className="subHead">{translate('personal_information_collection.from_whom.title')}</div>
                    <ul>
                        <li>{translate('personal_information_collection.from_whom.content_1')}</li>
                        <li>{translate('personal_information_collection.from_whom.content_2')}</li>
                    </ul>

                    <div className="headText">{translate('personal_information_collection.purpose.title')}</div>
                    <div className="subHead">{translate('personal_information_collection.purpose.subTitle')}</div>
                    <ul>
                        <li>{translate('personal_information_collection.purpose.content_1')}</li>
                        <li>{translate('personal_information_collection.purpose.content_2')}</li>
                        <li>{translate('personal_information_collection.purpose.content_3')}</li>
                        <li>{translate('personal_information_collection.purpose.content_4')}</li>
                        <li>{translate('personal_information_collection.purpose.content_5')}</li>
                        <li>{translate('personal_information_collection.purpose.content_6')}</li>
                        <li>{translate('personal_information_collection.purpose.content_7')}</li>
                        <li>{translate('personal_information_collection.purpose.content_8')}</li>
                        <li>{translate('personal_information_collection.purpose.content_9')}</li>
                        <li>{translate('personal_information_collection.purpose.content_10')}</li>
                    </ul>
                </section>

                <section>
                    {/* <p className="headText">{translate('purpose_collecting_processing.title')}</p> */}
                    {/* <p>{translate('purpose_collecting_processing.content')}</p> */}
                    <div className="subHead">{translate('purpose_collecting_processing.legal_basis.title')}</div>
                    <p>{translate('purpose_collecting_processing.legal_basis.content')}</p>
                    <div className="subHead">{translate('purpose_collecting_processing.data_protection.title')}</div>
                    <p>{translate('purpose_collecting_processing.data_protection.content')}</p>
                </section>

                <section>
                    <p className="headText">{translate('data_retention.title')}</p>
                    <p dangerouslySetInnerHTML={{ __html: translate('data_retention.content') }}></p>
                    <p>{translate('data_retention.content_2')}</p>
                </section>

                <section>
                    <p className="headText">{translate('data_sharing.title')}</p>
                    <p>{translate('data_sharing.content')}</p>
                </section>

                <section>
                    <p className="headText">{translate('minors_privacy.title')}</p>
                    <p>{translate('minors_privacy.content')}</p>
                </section>

                <section>
                    <p className="headText">{translate('changes_notice.title')}</p>
                    <p>{translate('changes_notice.content')}</p>
                </section>

                <section>
                    <p className="headText">{translate('data_subject_choices.title')}</p>
                    <p>{translate('data_subject_choices.title_content')}</p>
                    <ul>
                        <li>{translate('data_subject_choices.choice_1')}</li>
                        <li>{translate('data_subject_choices.choice_2')}</li>
                        <li>{translate('data_subject_choices.choice_3')}</li>
                        <li>{translate('data_subject_choices.choice_4')}</li>
                        <li>{translate('data_subject_choices.choice_5')}</li>
                        <li>{translate('data_subject_choices.choice_6')}</li>
                    </ul>
                    {/* <p>{translate('data_subject_choices.content')}</p> */}
                    <p>{translate('data_subject_choices.para_1')}</p>
                    <p>{translate('data_subject_choices.para_2')}</p>
                    <p>{translate('data_subject_choices.para_3')}</p>
                    <p>{translate('data_subject_choices.para_4')}</p>
                    <p>{translate('data_subject_choices.para_5')}</p>
                </section>

                <section>
                    <p className="headText">{translate('data_access_correction.title')}</p>
                    <p>{translate('data_access_correction.content')}</p>
                </section>

                <section>
                    <p>{translate('last_updated.content')}</p>
                </section>


            </Modal>
        </>
    );
}

export default PrivacyModal